import { Injectable } from '@angular/core';
import { RestApi } from 'app/auth/rest.api';

@Injectable({
  providedIn: 'root'
})
export class ConnectTriggersService {

  private _endPoints = {
    getTriggersConnection: 'api/ExternalSystem/TriggersConnections',
    getTriggersConnectionEnvrion: 'api/ExternalSystem/TriggerConnectionEnviron',
    saveTriggerConnectionEnviron: 'api/ExternalSystem/TriggerConnectionEnviron'
  };

  constructor(private _restApi: RestApi) { }

  public getTriggersConnections(): Promise<ITriggerConnectionModelType[]> {
    return this._restApi.get(this._endPoints.getTriggersConnection).toPromise() as Promise<ITriggerConnectionModelType[]>;
  }
  public getTriggersConnectionsEnviron(parentId): Promise<ITriggerConnectionEnvironment> {
    return this._restApi.get(`${this._endPoints.getTriggersConnectionEnvrion}/${parentId}`).toPromise() as Promise<ITriggerConnectionEnvironment>;
  }
  public saveTriggerConnectionEnviron(triggerConnectionEnviron: any): Promise<ITriggerConnectionEnvironment> {
    return this._restApi.put(this._endPoints.saveTriggerConnectionEnviron, triggerConnectionEnviron).toPromise() as Promise<ITriggerConnectionEnvironment>;
  }
}
